import { useMutation, useQueryClient } from '@tanstack/react-query';

import createPrivateAdminPanelInstance from '../api/PrivateAdminPanelInstance';
import { API_ROUTES } from '../api/ApiRoutes';

const postReorderLiveEvents = async ({ orderedIds, parentId }) => {
  const payload = {
    entity_type: 'LIVE',
    item_type: 'EVENT',
    ordered_ids: orderedIds,
    parent_id: parentId,
  };

  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.REORDER_ENTITIES,
    payload
  );

  return response.data;
};

export const useReorderLiveEvents = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['REORDER_ENTITIES'],
    mutationFn: postReorderLiveEvents,

    onMutate: async ({ orderedIds, parentId, sportId }) => {
      await queryClient.cancelQueries(['GET_LIVE_EVENT_ENTITIES', sportId]);

      const previous = queryClient.getQueryData([
        'GET_LIVE_EVENT_ENTITIES',
        sportId,
      ]);

      queryClient.setQueryData(['GET_LIVE_EVENT_ENTITIES', sportId], (old) => {
        if (!old) return old;
        return old.map((league) =>
          league.league_id === parentId
            ? {
                ...league,
                events: orderedIds.map((id, i) => ({
                  ...league.events.find((event) => event.entity_id === id),
                  display_order: i + 1,
                })),
              }
            : league
        );
      });

      return { previous, sportId };
    },

    onError: (_err, _vars, ctx) => {
      if (ctx?.previous) {
        queryClient.setQueryData(
          ['GET_LIVE_EVENT_ENTITIES', ctx.sportId],
          ctx.previous
        );
      }
    },

    onSettled: (_data, _err, variables) => {
      queryClient.invalidateQueries([
        'GET_LIVE_EVENT_ENTITIES',
        variables.sportId,
      ]);
    },
  });
};

